import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_107_add_inspection: any[] = [
  {
      "componentType": "screenGroup",
      "title": "Add Inspection",
      "style": {},
      "childComponents": [
          {
              "componentType": "form",
              "Name": "vehicle_in",
              "columnNumber": "m1 t1 w1",
              "TableName": "service_details",
              "Workflow": "service",
              "Plugins": [
                  {
                      "type": "api"
                  }
              ],
              "DisplayName": "Inspection in",
              "style": {
                  "backgroundColor": "#ffffff",
                  "direction": "column"
              },
              "formActions": [
                  {
                      "name": "lock",
                      "type": "lock",
                      "icon": "lock",
                      "onPressAction": "unlock"
                  },
                  {
                      "name": "Print",
                      "icon": "print",
                      "type": "pdf",
                      "onPressAction": "pdf_inspection"
                  }
              ],
              "Fields": [
                  {
                      "componentType": "fieldGroup",
                      "orientation": "row",
                      "style": {
                          "direction": "column"
                      },
                      "childComponents": [
                          {
                              "IncludeLabel": true,
                              "Label": "VIN No.",
                              "PlaceHolder": "Will be auto generated...",
                              "IsMandatory": false,
                              "BindValue": "vin_number",
                              "Json_Attribute": "vin_no",
                              "componentType": "textField",
                              "showInSummary": true,
                              "IsReadOnly": true,
                              "AutoPopulate": true,
                              "AutoPopulate_format": "VIN_[******]",
                              "IsVerticalView": true,
                              "inputType": "text"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "VIN date",
                              "PlaceHolder": "",
                              "IsMandatory": true,
                              "BindValue": "vin_date",
                              "Json_Attribute": "vin_date",
                              "IsReadOnly": false,
                              "componentType": "datetimeField",
                              "showInSummary": true,
                              "IsVerticalView": true,
                              "DefaultToday": true,
                              "maxDate": "today"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Reg No.",
                              "PlaceHolder": "",
                              "IsMandatory": true,
                              "BindValue": "drp_veh_reg_no",
                              "Json_Attribute": "vehicle_id",
                              "componentType": "searchableDropdown",
                              "showInSummary": false,
                              "LookupName": "vehicle_no_inspection_withlock",
                              "optionLock": "lock_status",
                              "IsVerticalView": true,
                              "EnableEditForControl": false,
                              "BindScreen": {
                                  "EnableAdding": true,
                                  "BindScreen": "vehicle_add_from_modal"
                              }
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Vehicle make",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "txt_vehicle_make",
                              "Json_Attribute": "vehicle_make",
                              "IsReadOnly": true,
                              "componentType": "textField",
                              "showInSummary": true,
                              "BindParent": {
                                  "drp_veh_reg_no": "vmake"
                              },
                              "IsVerticalView": true,
                              "inputType": "text"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Vehicle type",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "txt_vehicle_type",
                              "Json_Attribute": "vehicle_type",
                              "componentType": "textField",
                              "showInSummary": true,
                              "IsReadOnly": true,
                              "BindParent": {
                                  "drp_veh_reg_no": "vehicletype"
                              },
                              "IsVerticalView": true,
                              "inputType": "text"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Vehicle model",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "txt_vehicle_model",
                              "Json_Attribute": "vehicle_model",
                              "componentType": "textField",
                              "showInSummary": true,
                              "IsReadOnly": true,
                              "BindParent": {
                                  "drp_veh_reg_no": "model"
                              },
                              "IsVerticalView": true,
                              "inputType": "text"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Customer name",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "txt_customer_name",
                              "Json_Attribute": "customer_name",
                              "componentType": "textField",
                              "showInSummary": true,
                              "IsReadOnly": true,
                              "BindParent": {
                                  "drp_veh_reg_no": "customerid"
                              },
                              "IsVerticalView": true,
                              "inputType": "text"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Engine number",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "txt_engine_number",
                              "Json_Attribute": "vehicle_eng_no",
                              "componentType": "textField",
                              "IsReadOnly": true,
                              "showInSummary": true,
                              "BindParent": {
                                  "drp_veh_reg_no": "engine_no"
                              },
                              "IsVerticalView": true,
                              "inputType": "text"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Chassis No.",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "txt_chasis_number",
                              "Json_Attribute": "vehicle_chas_no",
                              "componentType": "textField",
                              "IsReadOnly": true,
                              "showInSummary": true,
                              "BindParent": {
                                  "drp_veh_reg_no": "chasis_no"
                              },
                              "IsVerticalView": true,
                              "inputType": "text"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "KM",
                              "PlaceHolder": "",
                              "IsMandatory": true,
                              "BindValue": "txt_km",
                              "Json_Attribute": "km",
                              "componentType": "textField",
                              "showInSummary": true,
                              "IsVerticalView": true,
                              "inputType": "number",
                              "validation": [
                                  {
                                      "rule": "pattern",
                                      "value": "^[0-9]*$",
                                      "message": "Invalid KM"
                                  }
                              ]
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Job category",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "drp_job_category",
                              "Json_Attribute": "job_category_id",
                              "componentType": "searchableDropdown",
                              "showInSummary": true,
                              "LookupName": "job_category",
                              "IsVerticalView": true
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Salesman",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "drp_salesman",
                              "Json_Attribute": "salesman_id",
                              "componentType": "searchableDropdown",
                              "showInSummary": true,
                              "LookupName": "salesman_union",
                              "BindScreen": {
                                  "EnableAdding": true,
                                  "BindScreen": "emp_add_from_modal"
                              },
                              "IsVerticalView": true
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Service advisor",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "drp_service_advisor",
                              "Json_Attribute": "service_advisor_id",
                              "componentType": "searchableDropdown",
                              "showInSummary": true,
                              "LookupName": "service_advisor",
                              "IsVerticalView": true
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Fuel level",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "drp_fuel_level",
                              "Json_Attribute": "fuel_level",
                              "componentType": "searchableDropdown",
                              "showInSummary": false,
                              "LookupName": "fuel_level",
                              "IsVerticalView": true
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Driver name",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "txt_driver_name",
                              "Json_Attribute": "driver_name",
                              "componentType": "textField",
                              "showInSummary": false,
                              "IsVerticalView": true,
                              "inputType": "text",
                              "validation": [
                                  {
                                      "rule": "pattern",
                                      "value": "^[A-Za-z ]+$",
                                      "message": "Only alphabets and spaces are allowed"
                                  }
                              ]
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Driver mobile",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "txt_driver_mobile",
                              "Json_Attribute": "drive_mobile",
                              "componentType": "textField",
                              "showInSummary": false,
                              "IsVerticalView": true,
                              "required": false,
                              "inputType": "number",
                              "validation": [
                                  {
                                      "rule": "pattern",
                                      "value": "^[0-9]+$",
                                      "message": "mobile number should be valid"
                                  }
                              ]
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Remarks",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "txt_Remarks",
                              "Json_Attribute": "remarks",
                              "componentType": "textField",
                              "showInSummary": false,
                              "IsVerticalView": true,
                              "inputType": "text"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Delivery date",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "dt_del",
                              "Json_Attribute": "del_time",
                              "componentType": "dateField",
                              "showInSummary": false,
                              "IsVerticalView": true,
                              "DefaultToday": true,
                              "minDate": "today"
                          }
                      ]
                  },
                  {
                      "componentType": "subModule",
                      "Label": "Customer verbatim",
                      "TableName": "service_cust_verbatim",
                      "Name": "service_cust_verbatim",
                      "BindValue": "sub_Checklist",
                      "DisableAddNewRow": true,
                      "maxInstanceCount": 1,
                      "childControls": [
                          {
                              "IncludeLabel": true,
                              "Label": "Remarks 1",
                              "PlaceHolder": "Enter remarks here...",
                              "IsMandatory": false,
                              "BindValue": "txt_remarks1",
                              "Json_Attribute": "remarks",
                              "componentType": "textField"
                          }
                      ]
                  },
                  {
                      "componentType": "multiSubList",
                      "Label": "Inspection items",
                      "TableName": "service_checklist",
                      "Name": "service_checklist",
                      "BindValue": "multi_Checklist",
                      "LookupName": "inpection_items",
                      "childComponents": [
                          {
                              "IncludeLabel": true,
                              "Label": "SL No.",
                              "InputValue": "<SLNO>",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "lbl_sl",
                              "Json_Attribute": "sl_no",
                              "componentType": "textField"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Inspection items",
                              "InputValue": "<name>",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "lbl_inspection_items",
                              "Json_Attribute": "inspection_item",
                              "componentType": "textField"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Attention",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "Chk_A",
                              "Json_Attribute": "checked_a",
                              "componentType": "radioField"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Caution",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "Chk_B",
                              "Json_Attribute": "checked_b",
                              "componentType": "radioField"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Satisfaction ",
                              "PlaceHolder": "",
                              "IsMandatory": false,
                              "BindValue": "Chk_C",
                              "Json_Attribute": "checked_c",
                              "componentType": "radioField"
                          }
                      ]
                  },
                  {
                      "IncludeLabel": true,
                      "Label": "Work requested",
                      "PlaceHolder": "",
                      "TableName": "vehicle_work_requested",
                      "Name": "vehiclein_work_requested",
                      "IsMandatory": false,
                      "BindValue": "multi_work_request",
                      "Json_Attribute": "work_requested_id",
                      "componentType": "multiCheckbox",
                      "LookupName": "work_request"
                  },
                  {
                      "IncludeLabel": true,
                      "Label": "Vehicle check",
                      "SubLabel": "Does the vehicle have any dents or damage?",
                      "PlaceHolder": "",
                      "TableName": "vehicle_check",
                      "Name": "vehicle_check",
                      "IsMandatory": false,
                      "BindValue": "multi_vehicle_check",
                      "Json_Attribute": "vehicle_check_id",
                      "componentType": "vehicleInspection",
                      "componentVisiblity": [
                          "mobile"
                      ],
                      "vehicleType": "bus",
                      "vehicleTypeOptions": [
                          {
                              "value": "bus",
                              "label": "Bus"
                          },
                          {
                              "value": "car",
                              "label": "Car"
                          },
                          {
                              "value": "suv",
                              "label": "SUV"
                          },
                          {
                              "value": "truck",
                              "label": "Truck"
                          }
                      ],
                      "points": {
                          "car": {
                              "front": {
                                  "image": "img_car_front.png",
                                  "points": [
                                      {
                                          "id": "mirror_left",
                                          "name": "Left Mirror",
                                          "x": 12,
                                          "y": 30
                                      },
                                      {
                                          "id": "mirror_right",
                                          "name": "Right Mirror",
                                          "x": 89,
                                          "y": 30
                                      },
                                      {
                                          "id": "left_headlight",
                                          "name": "Left Headlight",
                                          "x": 19,
                                          "y": 44
                                      },
                                      {
                                          "id": "right_headlight",
                                          "name": "Right Headlight",
                                          "x": 82,
                                          "y": 45
                                      },
                                      {
                                          "id": "front_bumper",
                                          "name": "Front Bumper",
                                          "x": 50,
                                          "y": 39
                                      }
                                  ]
                              },
                              "back": {
                                  "image": "img_car_back.png",
                                  "points": [
                                      {
                                          "id": "taillight_left",
                                          "name": "Left Tail Light",
                                          "x": 17,
                                          "y": 50
                                      },
                                      {
                                          "id": "taillight_right",
                                          "name": "Right Tail Light",
                                          "x": 85,
                                          "y": 49
                                      },
                                      {
                                          "id": "rear_bumper",
                                          "name": "Rear Bumper",
                                          "x": 50,
                                          "y": 64
                                      }
                                  ]
                              },
                              "side1": {
                                  "image": "img_car_side_1.png",
                                  "points": [
                                      {
                                          "id": "front_wheel_left",
                                          "name": "Front Left Wheel",
                                          "x": 80,
                                          "y": 59
                                      },
                                      {
                                          "id": "rear_wheel_left",
                                          "name": "Rear Left Wheel",
                                          "x": 17,
                                          "y": 60
                                      }
                                  ]
                              },
                              "side2": {
                                  "image": "img_car_side_2.png",
                                  "points": [
                                      {
                                          "id": "front_wheel_right",
                                          "name": "Front Right Wheel",
                                          "x": 22,
                                          "y": 60
                                      },
                                      {
                                          "id": "rear_wheel_right",
                                          "name": "Rear Right Wheel",
                                          "x": 85,
                                          "y": 59
                                      }
                                  ]
                              }
                          },
                          "bus": {
                              "front": {
                                  "image": "img_bus_front.png",
                                  "points": [
                                      {
                                          "id": "windshield",
                                          "name": "Windshield",
                                          "x": 50,
                                          "y": 30
                                      },
                                      {
                                          "id": "mirror_left",
                                          "name": "Left Mirror",
                                          "x": 24,
                                          "y": 30
                                      },
                                      {
                                          "id": "mirror_right",
                                          "name": "Right Mirror",
                                          "x": 76,
                                          "y": 29
                                      },
                                      {
                                          "id": "headlight_left",
                                          "name": "Left Headlight",
                                          "x": 32,
                                          "y": 63
                                      },
                                      {
                                          "id": "headlight_right",
                                          "name": "Right Headlight",
                                          "x": 70,
                                          "y": 65
                                      },
                                      {
                                          "id": "front_bumper",
                                          "name": "Front Bumper",
                                          "x": 50,
                                          "y": 70
                                      }
                                  ]
                              },
                              "back": {
                                  "image": "img_bus_back.png",
                                  "points": [
                                      {
                                          "id": "rear_glass",
                                          "name": "Rear Glass",
                                          "x": 50,
                                          "y": 25
                                      },
                                      {
                                          "id": "tail_light_left",
                                          "name": "Left Tail Light",
                                          "x": 25,
                                          "y": 58
                                      },
                                      {
                                          "id": "tail_light_right",
                                          "name": "Right Tail Light",
                                          "x": 76,
                                          "y": 60
                                      },
                                      {
                                          "id": "rear_bumper",
                                          "name": "Rear Bumper",
                                          "x": 50,
                                          "y": 70
                                      }
                                  ]
                              },
                              "side1": {
                                  "image": "img_bus_side_1.png",
                                  "points": [
                                      {
                                          "id": "side_window_left",
                                          "name": "Left Side Window",
                                          "x": 44,
                                          "y": 39
                                      },
                                      {
                                          "id": "wheel_front_left",
                                          "name": "Left Front Wheel",
                                          "x": 73,
                                          "y": 60.5
                                      },
                                      {
                                          "id": "wheel_rear_left",
                                          "name": "Left Rear Wheel",
                                          "x": 28.5,
                                          "y": 60.5
                                      }
                                  ]
                              },
                              "side2": {
                                  "image": "img_bus_side_2.png",
                                  "points": [
                                      {
                                          "id": "side_window_right",
                                          "name": "Right Side Window",
                                          "x": 44,
                                          "y": 39
                                      },
                                      {
                                          "id": "wheel_front_right",
                                          "name": "Right Front Wheel",
                                          "x": 27,
                                          "y": 60.5
                                      },
                                      {
                                          "id": "wheel_rear_right",
                                          "name": "Right Rear Wheel",
                                          "x": 71,
                                          "y": 60.5
                                      }
                                  ]
                              }
                          },
                          "car2": {
                              "front": {
                                  "image": "img_car2_front.png",
                                  "points": [
                                      {
                                          "id": "mirror_left",
                                          "name": "Left Mirror",
                                          "x": 12,
                                          "y": 30
                                      },
                                      {
                                          "id": "mirror_right",
                                          "name": "Right Mirror",
                                          "x": 89,
                                          "y": 30
                                      },
                                      {
                                          "id": "left_headlight",
                                          "name": "Left Headlight",
                                          "x": 19,
                                          "y": 44
                                      },
                                      {
                                          "id": "right_headlight",
                                          "name": "Right Headlight",
                                          "x": 82,
                                          "y": 45
                                      },
                                      {
                                          "id": "front_bumper",
                                          "name": "Front Bumper",
                                          "x": 50,
                                          "y": 39
                                      }
                                  ]
                              },
                              "back": {
                                  "image": "img_car2_back.png",
                                  "points": [
                                      {
                                          "id": "taillight_left",
                                          "name": "Left Tail Light",
                                          "x": 17,
                                          "y": 50
                                      },
                                      {
                                          "id": "taillight_right",
                                          "name": "Right Tail Light",
                                          "x": 85,
                                          "y": 49
                                      },
                                      {
                                          "id": "rear_bumper",
                                          "name": "Rear Bumper",
                                          "x": 50,
                                          "y": 64
                                      }
                                  ]
                              },
                              "side1": {
                                  "image": "img_car2_side1.png",
                                  "points": [
                                      {
                                          "id": "front_wheel_left",
                                          "name": "Front Left Wheel",
                                          "x": 80,
                                          "y": 59
                                      },
                                      {
                                          "id": "rear_wheel_left",
                                          "name": "Rear Left Wheel",
                                          "x": 17,
                                          "y": 60
                                      }
                                  ]
                              },
                              "side2": {
                                  "image": "img_car2_side2.png",
                                  "points": [
                                      {
                                          "id": "front_wheel_right",
                                          "name": "Front Right Wheel",
                                          "x": 22,
                                          "y": 60
                                      },
                                      {
                                          "id": "rear_wheel_right",
                                          "name": "Rear Right Wheel",
                                          "x": 85,
                                          "y": 59
                                      }
                                  ]
                              }
                          },
                          "suv": {
                              "front": {
                                  "image": "img_suv_front.png",
                                  "points": [
                                      {
                                          "id": "mirror_left",
                                          "name": "Left Mirror",
                                          "x": 13,
                                          "y": 32
                                      },
                                      {
                                          "id": "mirror_right",
                                          "name": "Right Mirror",
                                          "x": 87,
                                          "y": 32
                                      },
                                      {
                                          "id": "left_headlight",
                                          "name": "Left Headlight",
                                          "x": 21,
                                          "y": 51
                                      },
                                      {
                                          "id": "right_headlight",
                                          "name": "Right Headlight",
                                          "x": 79,
                                          "y": 51
                                      },
                                      {
                                          "id": "front_bumper",
                                          "name": "Front Bumper",
                                          "x": 50,
                                          "y": 73
                                      }
                                  ]
                              },
                              "back": {
                                  "image": "img_suv_back.png",
                                  "points": [
                                      {
                                          "id": "taillight_left",
                                          "name": "Left Tail Light",
                                          "x": 17,
                                          "y": 50
                                      },
                                      {
                                          "id": "taillight_right",
                                          "name": "Right Tail Light",
                                          "x": 85,
                                          "y": 49
                                      },
                                      {
                                          "id": "rear_bumper",
                                          "name": "Rear Bumper",
                                          "x": 50,
                                          "y": 64
                                      }
                                  ]
                              },
                              "side1": {
                                  "image": "img_suv_side_1.png",
                                  "points": [
                                      {
                                          "id": "front_wheel_left",
                                          "name": "Front Left Wheel",
                                          "x": 80,
                                          "y": 59
                                      },
                                      {
                                          "id": "rear_wheel_left",
                                          "name": "Rear Left Wheel",
                                          "x": 17,
                                          "y": 60
                                      }
                                  ]
                              },
                              "side2": {
                                  "image": "img_suv_side2.png",
                                  "points": [
                                      {
                                          "id": "front_wheel_right",
                                          "name": "Front Right Wheel",
                                          "x": 22,
                                          "y": 60
                                      },
                                      {
                                          "id": "rear_wheel_right",
                                          "name": "Rear Right Wheel",
                                          "x": 85,
                                          "y": 59
                                      }
                                  ]
                              }
                          },
                          "truck": {
                              "front": {
                                  "image": "img_truck_front.png",
                                  "points": [
                                      {
                                          "id": "mirror_left",
                                          "name": "Left Mirror",
                                          "x": 12,
                                          "y": 30
                                      },
                                      {
                                          "id": "mirror_right",
                                          "name": "Right Mirror",
                                          "x": 89,
                                          "y": 30
                                      },
                                      {
                                          "id": "left_headlight",
                                          "name": "Left Headlight",
                                          "x": 19,
                                          "y": 44
                                      },
                                      {
                                          "id": "right_headlight",
                                          "name": "Right Headlight",
                                          "x": 82,
                                          "y": 45
                                      },
                                      {
                                          "id": "front_bumper",
                                          "name": "Front Bumper",
                                          "x": 50,
                                          "y": 39
                                      }
                                  ]
                              },
                              "back": {
                                  "image": "img_truck_back.png",
                                  "points": [
                                      {
                                          "id": "taillight_left",
                                          "name": "Left Tail Light",
                                          "x": 17,
                                          "y": 50
                                      },
                                      {
                                          "id": "taillight_right",
                                          "name": "Right Tail Light",
                                          "x": 85,
                                          "y": 49
                                      },
                                      {
                                          "id": "rear_bumper",
                                          "name": "Rear Bumper",
                                          "x": 50,
                                          "y": 64
                                      }
                                  ]
                              },
                              "side1": {
                                  "image": "img_truck_side_1.png",
                                  "points": [
                                      {
                                          "id": "front_wheel_left",
                                          "name": "Front Left Wheel",
                                          "x": 24,
                                          "y": 60
                                      },
                                      {
                                          "id": "rear_wheel_left",
                                          "name": "Rear Left Wheel",
                                          "x": 78,
                                          "y": 60
                                      }
                                  ]
                              },
                              "side2": {
                                  "image": "img_truck_side_2.png",
                                  "points": [
                                      {
                                          "id": "front_wheel_right",
                                          "name": "Front Right Wheel",
                                          "x": 76,
                                          "y": 60
                                      },
                                      {
                                          "id": "rear_wheel_right",
                                          "name": "Rear Right Wheel",
                                          "x": 22,
                                          "y": 59
                                      }
                                  ]
                              }
                          }
                      },
                      "childComponents": [
                          {
                              "IncludeLabel": true,
                              "Label": "Incident name",
                              "PlaceHolder": "Enter remarks here...",
                              "IsMandatory": false,
                              "BindValue": "txt_incident_name",
                              "Json_Attribute": "inspection_incident_name",
                              "componentType": "textField"
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Upload Image/Videos",
                              "IsMandatory": false,
                              "BindValue": "image_file_upload",
                              "Json_Attribute": "file_incident_image",
                              "componentType": "multiFileUpload",
                              "maxImages": 3,
                              "maxVideos": 3
                          },
                          {
                              "IncludeLabel": true,
                              "Label": "Description",
                              "PlaceHolder": "Enter Description here...",
                              "IsMandatory": false,
                              "BindValue": "txt_incident_description",
                              "Json_Attribute": "inspection_incident_description",
                              "componentType": "textField"
                          }
                      ]
                  }
              ]
          },
          {
              "componentType": "button",
              "name": "Save",
              "onPressAction": "save",
              "style": {
                  "backgroundColor": ""
              }
          }
      ]
  }
];
